import { useTranslate } from 'react-polyglot'
import { Link } from 'react-router-dom'
import { Typography } from '@getgo/chameleon-web-react-wrapper'
import { Box, Grid } from '@material-ui/core'

import { useSupportUrl } from 'hooks'

interface NoResultOptionProps {
  keyword: string
}

const NoResultOption = ({ keyword }: NoResultOptionProps): JSX.Element => {
  const t = useTranslate()
  const supportUrl = useSupportUrl()

  return (
    <Box whiteSpace="nowrap" textOverflow="ellipsis" overflow="hidden" data-testid="no-result-option">
      <Grid container spacing={2}>
        <Grid item>
          <Grid container direction="row" alignContent="center" spacing={1}>
            <Grid item>{t('No results for')}</Grid>
            <Grid item>
              <Typography variant="body-medium-strong">{`"${keyword}"`}</Typography>
            </Grid>
          </Grid>
        </Grid>
        <Grid item>
          {t('Try a different phrasing or visit our ')}

          <Link
            onMouseDown={() => {
              // onMouseDown is used cause the noOptionsText doesn't trigger the onClick event
              window.open(supportUrl)
            }}
            target="_blank"
            to={supportUrl}
            rel="noopener noreferrer"
          >
            {t('support site.')}
          </Link>
        </Grid>
      </Grid>
    </Box>
  )
}

export default NoResultOption
